if($('.in-index').length){
    $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
            //  console.log(index);
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
          });
        });
    });
    if($('.customesrFeed').length){
      $('.customesrFeed').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 5000,
          dots: true,
          arrows: false,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
  
           
           {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
               
              }
            },
            {
              breakpoint: 768,
              settings: {
               slidesToShow: 2,
               slidesToScroll: 2,
             }
             
            },
            
            {
              breakpoint: 330,
              settings: {
               slidesToShow: 1,
               slidesToScroll: 2,
             }
             
            }
            
          ]
      });
  } 
}